import React from "react";
import styled, { css } from "styled-components";
import ReactPlayer from "react-player";
import withLocalization from "../../hoc/withLocalization";
import {
  ENGLISH,
  RIGHT_TO_LEFT
} from "../../state/actions/localization.action";
const BigView = props => {
  const { next, item, i18n } = props;
  return (
    <Container>
      <Background>
        <VideoBack url={item.video} muted playing width="100%" />
      </Background>
      <RealVideo
        url={item.video}
        muted
        playing
        height="100%"
        width="80%"
        onEnded={next}
        style={{ zIndex: 3 }}
      />
      <TitleAndDesc i18n={i18n}>
        <h1>{i18n.name === ENGLISH ? item.en.title : item.ar.title}</h1>
        <p>{i18n.name === ENGLISH ? item.en.desc : item.ar.desc}</p>
      </TitleAndDesc>
    </Container>
  );
};
const TitleAndDesc = styled.div`
  background: linear-gradient(to top, #000, #0000);
  position: absolute;
  bottom: 0;
  left: 10%;
  right: 10%;
  z-index: 4;

  padding: 20px;

  h1 {
    ${props =>
      props.i18n.dir === RIGHT_TO_LEFT &&
      css`
        float: right;
      `}
    color: white;
  }
  p {
    ${props =>
      props.i18n.dir === RIGHT_TO_LEFT &&
      css`
        float: right;
        direction: rtl;
      `}
    color: white;
  }
`;

const VideoBack = styled(ReactPlayer)`
  video {
    height: 600px !important;
    filter: blur(40px);
    opacity: 0.4;
  }
`;

const RealVideo = styled(ReactPlayer)`
  video {
    object-fit: cover;
  }
`;

const Background = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1;
`;

const Container = styled.div`
  flex: 3;
  justify-content: center;
  padding-top: 20px;
  align-items: center;
  display: flex;
  height: 530px;
  position: relative;
`;

export default withLocalization(BigView);
